import {
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box
} from "@chakra-ui/react";
import JsonView from "@uiw/react-json-view";

const Event = ({ event, timestamp }) => {
    const isClient = event.event_id && !event.event_id.startsWith("event_");
    return (
        <AccordionItem value={event.event_id} border="none" mb={2}>
            <AccordionButton
                _expanded={{ bg: "blue.50", color: "blue.700" }}
                borderRadius="md"
                py={2}
                gap={2}
            >
                <AccordionIcon />
                <Box flex="1" textAlign="left">
                    <Box as="span" fontWeight="bold">
                        {isClient ? "Client:" : "Server:"}
                    </Box>
                    &nbsp;{event.type} | {timestamp}
                </Box>
            </AccordionButton>
            <AccordionPanel pb={4}>
                <Box
                    borderRadius="md"
                    p={2}
                    bg="gray.50"
                    maxHeight="300px"
                    overflowY="auto"
                >
                    <JsonView
                        value={event}
                        displayDataTypes={false}
                        displayObjectSize={false}
                        collapsed={false}
                    />
                </Box>
            </AccordionPanel>
        </AccordionItem>
    );
};

export default Event;
